import React, { useCallback, useEffect, useState, useRef } from "react";
import { Box, Avatar, Tooltip, Dialog, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { PaperClipOutlined } from "@ant-design/icons";
// import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import sendImg from "../../assets/images/Vector.png";
import plusImg from "../../assets/images/plus.png";
import searchImg from "../../assets/images/search.png";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../utils/debounce";
// import AddChat from "./AddChat";
import Styles from "../../assets/styles/Chat.module.scss";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import io from "socket.io-client";
import axiosHttp from "../../services/interceptor.service";
import { useNavigate } from "react-router-dom";
import { getGroup } from "../../services/group.service";
// import { usePermissions } from "../../services/permissionProvider";

// const socket = io(process.env.REACT_APP_SOCKET_URL);
const ChatList = ({ refreshKey }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [action, setAction] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openChatDrawer, setOpenChatDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [openLoader, setOpenLoader] = useState(false);
  const [group, setGroup] = useState([]);
  const [openChat, setOpenChat] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState({});
  const [message, setMessage] = useState("");
  const [sendMessages, setSendMessages] = useState([]);
  const [receivedMessage, setReceivedMessage] = useState([]);
  const [searchText, setSearchText] = useState("");

  const scrollRef = useRef(null);
  const role = localStorage.getItem("role");
  const UserName = localStorage.getItem("userName");
  const UserId = localStorage.getItem("userId");

  const roleParam = {
    search: "",
    page: 1,
    limit: 12,
    sortType: "",
    sort: "",
    month: null,
  };

  const [queryParam, setQueryParam] = useState({
    get: "",
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    month: null,
  });

  const getRoleData = async () => {
    try {
      const res = await roleParam; // This seems to be incomplete; adjust based on your API logic
      const configData = res.data.map((e) => ({
        ...e,
        label: e.roleName,
      }));
      const roles = configData.find((r) => r.label === role);
      const roleId = roles ? roles._id : null;
      if (roleId) {
        setQueryParam((queryParam) => ({
          ...queryParam,
          get: roleId,
        }));
      }
    } catch (error) {
      console.error("Error fetching role data:", error);
    }
  };

  const handleGetGroup = async () => {
    try {
      const resp = await getGroup(); // Ensure getGroup() is defined and returns group data
      console.log("Groups:", resp.data);
      setGroup(resp.data.data);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const handleAdd = () => {
    navigate("/addChannel");
  };

  // const handleGroupValues = (group) => {
  //   setSelectedGroup(group);
  //   setOpenChat(true);
  //   console.log("Selected Group:", group);
  // };

  // const handleSendMessage = () => {
  //   if (message.trim()) {
  //     socket.emit("message", message);
  //     setMessage("");
  //   }
  // };

  useEffect(() => {
    if (role !== "WSH-ADMIN") {
      getRoleData();
    }
  }, [role]);

  const handleView = (e) => {
    setTimeout(() => {
      e.isView = true;
      setOpenChatDrawer(true);
    }, 700);
    setSelectedData(e);
  };

  const fetchChatData = () => {
    setOpenLoader(true);
    // Implement your API call here to fetch chat data
  };

  // useEffect(() => {
  //   socket.on("connection", (data) => {
  //     console.log("Socket Connected:", data);
  //   });
  //   handleGetGroup();
  //   return () => {
  //     socket.off("connection"); // Cleanup the socket listener
  //   };
  // }, []);

  const handleGroupValues = (group) => {
    setSelectedGroup(group);
    setOpenChat(true);
    console.log("Selected Group:", group);
  };

  useEffect(() => {
    if (selectedGroup?.groupName) {
      // Join the selected group
      // socket.emit("JOIN_ROOM", selectedGroup.groupName);

      // Cleanup: Leave the room and remove listeners when the group changes or component unmounts
      return () => {
        // socket.emit("LEAVE_ROOM", selectedGroup.groupName);
        // socket.off("receivedMessage"); // Remove all "receivedMessage" listeners
        console.log("Left room:", selectedGroup.groupName);
      };
    }
  }, [selectedGroup]);

  const handleSendMessage = () => {
    if (message.trim()) {
      // Send the message to the current room
      // socket.emit("message", { room: selectedGroup.groupName, message });
      // setReceivedMessage((prev) => [...prev, message]); // Add to local state
      setMessage(""); // Clear input after sending
    }
  };

  useEffect(() => {
    const handleReceivedMessage = (data) => {
      setReceivedMessage((prev) => [...prev, data]);
    };

    // Add a listener for received messages
    // socket.on("receivedMessage", handleReceivedMessage);

    // Cleanup: Remove the listener when the component unmounts
    return () => {
      // socket.off("receivedMessage", handleReceivedMessage);
    };
  }, []); // Empty dependency ensures this runs only once

  const handleSearch = (text) => {
    setSearchText(text);
  };
  console.log(receivedMessage, "🤘");
  return (
    <section
      style={{
        display: "grid",
        gridTemplateColumns: "2fr 4fr",
        height: "100vh",
        width: "80vw",
        marginRight: 0,
      }}
    >
      <div style={{ borderRight: "1px solid #E6E6E6" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "10px",
            boxSizing: "border-box",
            gap: "5px",
            height: "60px",
          }}
        >
          <div
            style={{
              background: "#F9FAFB",
              border: "1px solid #E4E7EC",
              height: "100%",
              width: "80%",
              borderRadius: "6px",
              outline: "none",
              padding: "5px",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img src={searchImg} alt={"search"} />
            <input
              style={{
                background: "none",
                outline: "none",
                height: "100%",
                width: "100%",
                border: "none",
                fontSize: "15px",
              }}
              placeholder="Search here..."
            />
          </div>
          <div
            style={{
              background: "#00675D",
              color: "white",
              borderRadius: "6px",
              width: "12%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={handleAdd}
          >
            <img src={plusImg} alt={"plus"} />
          </div>
        </div>
        {group.map((ele, ind) => {
          return (
            <>
              <div
                style={{
                  // background: "blue",
                  height: "60px",
                  width: "90%",
                  boxSizing: "border-box",
                  padding: "10px",
                  display: "flex",
                  borderBottom: "1px solid #E6E6E6",
                  marginLeft: "10px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                key={ind}
                onClick={() => handleGroupValues(ele)}
              >
                <Avatar
                  sx={{
                    background: "#26A69A",
                    color: "white",
                    fontSize: "15px",
                    fontWeight: 600,
                  }}
                >
                  {ele?.groupName[0]}
                </Avatar>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "5px",
                    boxSizing: "border-box",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#00675D",
                      fontWeight: 600,
                    }}
                  >
                    {ele?.groupName}
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#4D4D4D",
                      fontWeight: 600,
                    }}
                  >
                    message
                  </span>
                </div>
              </div>
            </>
          );
        })}
      </div>
      {openChat && (
        <div style={{ maxHeight: "100vh" }}>
          <div style={{ height: "10%", background: "#00675D", width: "100%" }}>
            <div
              style={{
                // background: "blue",
                height: "60px",
                width: "90%",
                boxSizing: "border-box",
                padding: "15px 35px",
                display: "flex",
              }}
            >
              <Avatar
                sx={{
                  background: "#FFFFFF",
                  color: "#000000",
                  fontSize: "15px",
                  fontWeight: 600,
                }}
              >
                {selectedGroup?.groupName[0]}
              </Avatar>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "5px",
                  boxSizing: "border-box",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    color: "white",
                    fontWeight: 600,
                  }}
                >
                  {selectedGroup?.groupName}
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#FFFFFF",
                    fontWeight: 600,
                  }}
                >
                  channel
                </span>
              </div>
            </div>
            <div></div>
          </div>
          <div className={"chat-board"}>
            {receivedMessage.map((msg, i) => (
              <div
                style={{
                  width: "100%",
                  marginTop: "10px",
                  padding: "10px",
                  boxSizing: "border-box",
                  zIndex: 2,
                }}
                key={i}
              >
                <div
                  style={{
                    background: "#F6F6F6",
                    color: "#0F1828",
                    width: "fit-content",
                    right: 0,
                    padding: "10px",
                    boxSizing: "border-box",
                    wordWrap: "break-word",
                    marginLeft: "auto",
                    borderRadius: "16px",
                  }}
                >
                  {msg}
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              height: "23%",
              background: "#FFFFFF",
              width: "100%",
              borderTop: "1px solid #E6E6E6",
              display: "flex",
              marginTop: "20px",
              zIndex: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: "10px",
                gap: "15px",
                marginLeft: "35px",
              }}
            >
              <div
                style={{
                  background: "#F6F7F7",
                  height: "35%",
                  width: "90%",
                  display: "flex",
                  borderRadius: "25px",
                  paddingLeft: "35px",
                  boxSizing: "border-box",
                  justifyContent: "space-between",
                }}
              >
                <input
                  style={{
                    width: "80%",
                    zIndex: 3,
                    outline: "none",
                    background: "none",
                    border: "none",
                    fontSize: "15px",
                  }}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message here..."
                />
                <div
                  style={{
                    width: "10%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <PaperClipOutlined
                    style={{ fontSize: "20px", cursor: "pointer", zIndex: 3 }}
                  />
                </div>
              </div>
              <div
                style={{
                  background: "#00675D",
                  height: "35%",
                  width: "6%",
                  borderRadius: "50%",
                  cursor: "pointer",
                  zIndex: 3,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={handleSendMessage}
              >
                <img src={sendImg} alt={"send"} />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ChatList;
